<template>
    <div class="delivery">
      <div class="content">
          <div class="delivery-teaser"></div>
          <div class="delivery-wrapper">
            <div class="delivery-info">
                <h2>Dostava</h2>
                <div class="element">
                    <font-awesome-icon :icon="['fas', 'clock']" />
                    <p class="delivery-description">
                        URNIK DOSTAVE: <br>vsak dan od 10:00 do 22:00 (naročila sprejemamo do 21:30), pet-sob do 23:00 (naročila do 22:30)
                    </p>
                </div>
                <div class="element">
                    <font-awesome-icon :icon="['fas', 'clock']" />
                    <p class="delivery-description">
                        MALICE: <br>pon-pet: 11:00-14:00
                    </p>
                </div>
                 <div class="element">
                    <font-awesome-icon :icon="['fas', 'truck']" />
                    <p class="delivery-description">
                        Dostavljamo na območju označenem na zemljevidu.
                    </p>
                </div>
                <div class="element">
                    <font-awesome-icon :icon="['fas', 'map-marker']" />
                    <p class="address">
                    PIZZERIA TABERNA<br>
                    KAMNIŠKA 56,<br>
                    1241 KAMNIK<br>
                    </p>
                </div>
                 <div class="element">
                    <font-awesome-icon :icon="['fas', 'mobile-alt']" />
                    <p class="delivery-phone">
                        01 839 47 52
                    </p>
                </div>
            </div>
            <div class="map">
                <iframe src="https://www.google.com/maps/d/embed?mid=1WqTpLPu2JZc_KrH-AEHnYAnk93Npc39P" width="640" height="480"></iframe>
            </div>
          </div>
      </div>
      <Button><router-link to="/cenik-za-dostavo">Poglej cenik za dostavo</router-link></Button>
    </div>
</template>

<script>

import Button from '@/components/Button/Button';

export default {
    components: {
        Button
    }
}
</script>

<style lang="scss">   
@import 'delivery.scss'
</style>